import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK, DARK_FIELDS_ON_CARD_HEADER_LINE, LIGHT, PRIMARY_HEADER_LINE } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    flexColumnContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
    },
    miniRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 5,
    },
    heading: {
      position: 'relative',
      borderBottom: `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}`,
      paddingBottom: 10,
      marginBottom: 15,
      fontSize: 17,
      color: theme.palette.type === 'dark' ? LIGHT : DARK,
      fontWeight: 500,
      '&::before': {
        content: '""',
        background: PRIMARY_HEADER_LINE,
        height: '1px',
        position: 'absolute',
        width: '20%',
        bottom: '-1px',
        left: '0',
      },
    },
    flexMiniColumnContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 5,
    },
    flexRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 15,
      marginTop: 10,
    },
    contactItem: {
      display: 'flex',
      gap: 5,
      alignItems: 'center',
      '& svg': {
        height: 20,
        width: 'auto',
        marginRight: 5,
      },
      '& > div:last-child': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  }),
);
